import { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import './login.css';
import Validation from './LoginValidation/Validation';
import { UserContext, getUserFromToken, sha256 } from '../../Utilis';
import { UserAPI } from '../../Api/UserAPI';
import axios from 'axios';

function LoginPage() {
    const [values, setValues] = useState({ email: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [backendError, setBackendError] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const { user, setUser } = useContext(UserContext);
    const handleInput = (event) => {
        setValues(prev => ({ ...prev, [event.target.name]: event.target.value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const err = Validation(values);
        setErrors(err);

        if (err.email === '' && err.password === '') {
            setLoading(true);
            let valuesForSubmit = { ...values };
            valuesForSubmit.password = sha256(valuesForSubmit.password);
            UserAPI.login(valuesForSubmit).then((res) => {
                if (res.data.id !== 0 && res.data) {
                    localStorage.setItem("rememberMe", rememberMe);
                    if (rememberMe) {
                        localStorage.setItem('token', res.data.token);
                    } else {
                        sessionStorage.setItem('token', res.data.token);
                    }
                    axios.defaults.headers.common['user_authorization'] = `Bearer ${res.data.token}`;
                    setUser(res.data.user);
                    navigate('/home/');
                } else {
                    setBackendError('Ne postoji zapis.');
                }
            }).catch((error) => {
                console.error('Došlo je do greške:', error);
                setBackendError('Došlo je do greške. Molimo pokušajte kasnije.');
            }).finally(() => {
                setLoading(false);
            });
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        delete axios.defaults.headers.common['user_authorization'];
        setUser(null);
        navigate('/');
    };

    useEffect(() => {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        if (token) {
            getUserFromToken(token, setUser, navigate, "/", "/home/");
        }
    }, [setUser, navigate]);

    if (user) {
        return (
            <div>
                <button onClick={handleLogout}>Odjava</button>
            </div>
        );
    }

    return (
        <div className='login-page'>
            <div className="heading-container">
                <a href='https://bluedatab.com/' target='_blank' rel='noopener noreferrer'>
                    <img src="/bluedatab-logo.png" alt="BlueDataB Logo" className="logo-bluedatab" />
                </a>
                {/* <h1 className="heading">Dobrodošli</h1>
                <div className="yellow-line"></div> */}
                    <img src="/centaurus-logo.png" alt="BlueDataB Logo" className="logo-bluedatab" />
                    <h3 className='sub-heading-p'>Dobrodošli na BlueDataB intranet</h3>
                <h3 className='sub-heading-p'>siguran pristup podacima i izvještajima.</h3>
            </div>
            <div className="login-container">
                <div className="login-box">
                    <h2>Sigurna prijava </h2>
                    {backendError && <p className="error-message">{backendError}</p>}
                    <form onSubmit={handleSubmit}>
                        <div className='form-group'>
                            <div className="input-container">
                                <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
                                <input
                                    type="email"
                                    placeholder='Email'
                                    name='email'
                                    value={values.email}
                                    onChange={handleInput}
                                    className="input-field"
                                />
                                {errors.email && <span className='error-message'>{errors.email}</span>}
                            </div>
                        </div>
                        <div className='form-group'>
                            <div className="password-input-container">
                                <FontAwesomeIcon icon={faLock} className="input-icon" />
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder='Lozinka'
                                    name='password'
                                    value={values.password}
                                    onChange={handleInput}
                                    className="password-input-field"
                                />
                                <button type="button" onClick={() => setShowPassword(!showPassword)} className="toggle-password">
                                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                </button>
                                {errors.password && <span className='error-message'>{errors.password}</span>}
                            </div>
                        </div>
                        <div className='remember'>
                            <input
                                type="checkbox"
                                id="rememberMe"
                                checked={rememberMe}
                                onChange={() => setRememberMe(!rememberMe)}
                            />
                            <label className='login-label' htmlFor="rememberMe">Zapamti me</label>
                        </div>
                        <button type="submit" className="btn" disabled={loading}>
                            {loading ? "Prijava..." : "Prijavite se"}
                        </button>
                    </form>
                  
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
